import { render, staticRenderFns } from "./TenderListOfferVersionSelector.vue?vue&type=template&id=136428b0&scoped=true&"
import script from "./TenderListOfferVersionSelector.vue?vue&type=script&lang=js&"
export * from "./TenderListOfferVersionSelector.vue?vue&type=script&lang=js&"
import style0 from "./TenderListOfferVersionSelector.vue?vue&type=style&index=0&id=136428b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136428b0",
  null
  
)

export default component.exports